const setDefaultPosition = () => {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
};

export default setDefaultPosition;
